import React, { useState, useEffect } from "react";
import { FaAngleRight } from "react-icons/fa6";
import { FaAngleLeft } from "react-icons/fa6";
const Slider = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Auto-advance slides (optional)
  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const goToPrevious = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    const newIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);

    // Reset transitioning after animation completes
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const goToNext = () => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    const newIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);

    // Reset transitioning after animation completes
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const goToSlide = (index) => {
    if (isTransitioning || index === currentIndex) return;

    setIsTransitioning(true);
    setCurrentIndex(index);

    // Reset transitioning after animation completes
    setTimeout(() => setIsTransitioning(false), 500);
  };

  return (
    <div className="slider-container">
      <h1>Our Partners</h1>
      <div className="slider">
        <div
          className="slides-container"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
            transition: isTransitioning ? "transform 0.5s ease-in-out" : "none",
          }}
        >
          
          {slides.map((slide, index) => (
            <div key={index} className="slide">
              <div className="slide-content">
                <div>
                  <img src={slide.image} />
                </div>
                <div>
                  <img src={slide.image2} />
                </div>
                <div>
                  <img src={slide.image3} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="button-dots">
        <div>
          <button className="slider-button" onClick={goToNext}>
            <FaAngleLeft />
          </button>
          <div className="dot">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`slider-dot ${index === currentIndex ? "active" : ""
                  }`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
          <button className="slider-button" onClick={goToPrevious}>
            <FaAngleRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Slider;
